import React from "react";

import { countryCodeList } from "constants/countryConstants";
import Dropdown from "konnekt/Dropdown";

const CountryDropdown = ({ selectedValue, onOptionClick }) => {
  const getCountryDropdownOptions = () => {
    return countryCodeList.map((item) => {
      return { label: item.name, value: item.initials };
    });
  };

  return (
    <Dropdown
      options={getCountryDropdownOptions()}
      selectedValue={selectedValue}
      onOptionClick={onOptionClick}
      styles={{
        header: {
          fontWeight: "400",
          fontSize: "1rem",
          height: "40px",
        },
      }}
    />
  );
};

export default CountryDropdown;
